import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export const remindersApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "remindersApi",
    baseUrl: "/api/reminders",
  }),
  reducerPath: "remindersApi",
  tagTypes: ["Reminders"],
  endpoints: (builder) => ({
    sendReminderNow: builder.mutation<
      { message: string; recipientCount: number; timestamp: string },
      { eventId?: string; fieldId?: string; documentId?: string }
    >({
      query: (body) => ({
        url: "/send",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Reminders" }],
    }),
  }),
});

export const { useSendReminderNowMutation } = remindersApi;
